import { render } from "./VideoList.vue?vue&type=template&id=7caed7a2&scoped=true&ts=true"
import script from "./VideoList.ts?vue&type=script&lang=ts"
export * from "./VideoList.ts?vue&type=script&lang=ts"

import "./VideoList.scss?vue&type=style&index=0&id=7caed7a2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caed7a2"]])

export default __exports__